import { createContext, useContext, useEffect, useState } from "react";

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState(() => localStorage.getItem("neo_currency") || "GTQ");

  useEffect(() => {
    localStorage.setItem("neo_currency", currency);
  }, [currency]);

  const toggle = () => setCurrency((c) => (c === "USD" ? "GTQ" : "USD"));

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, toggle }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error("useCurrency must be used within CurrencyProvider");
  return ctx;
}
